<kendo-dialog width="100%" height="100%" maxWidth="500px">
  @if (loading()) {
    <maximizer-loader type="legacy"></maximizer-loader>
  }
  <div class="reset flex flex-col h-full">
    <!-- titlebar -->
    <div class="title-bar px-2 py-1 gap-2 flex items-center bg-neutral-10">
      <span
        class="maximizer-icons icon-iq-boost icon-18 mb-0.5 shrink-0"
      ></span>

      <div class="flex flex-col min-w-0 flex-1 shrink-0">
        <p class="subtitle-2 text-neutral-90">
          {{ 'outlook.summarization.title' | translate }}
        </p>

        @if (name()) {
          <p class="text-body text-neutral-70 min-w-0 flex-1 truncate">
            {{ name() }}
          </p>
        }
      </div>
      <span
        kendoTooltip
        [tooltipTemplate]="tooltipTemplate"
        position="bottom"
        [callout]="false"
        [attr.aria-label]="
          (anonymizerEnabled()
            ? 'outlook.summarization.anonymizer.enabled'
            : 'outlook.summarization.anonymizer.disabled'
          ) | translate
        "
        [class]="
          anonymizerEnabled()
            ? 'maximizer-icons icon-anonymizer icon-16 shrink-0 text-bush-green-100'
            : 'fa-icons icon-unlock icon-14 shrink-0 text-neutral-60'
        "
        [title]="
          (anonymizerEnabled()
            ? 'outlook.summarization.anonymizer.enabled'
            : 'outlook.summarization.anonymizer.disabled'
          ) | translate
        "
      ></span>
      <button
        kendoButton
        themeColor="tertiary"
        iconClass="fa-icons icon-xmark icon-14"
        [attr.aria-label]="'outlook.buttons.close' | translate"
        class="small"
        (click)="closeDialog.emit()"
      ></button>
    </div>
    <!-- date range -->
    <div class="flex items-end gap-2 bg-neutral-5 justify-center p-2">
      <div class="basis-2/3">
        <kendo-label class="text-body text-neutral-90">
          {{ 'outlook.summarization.dateRange.title' | translate }}
        </kendo-label>
        <kendo-dropdownlist
          [data]="dateRanges"
          valueField="id"
          textField="text"
          [listHeight]="240"
          [valuePrimitive]="true"
          [(ngModel)]="selectedDateRangeId"
          (ngModelChange)="onDateRangeChange($event)"
          [popupSettings]="{
            appendTo: 'component',
          }"
        >
          <ng-template
            kendoDropDownListItemTemplate
            kendoDropDownListValueTemplate
            let-item
          >
            {{ item?.text | translate }}
          </ng-template>
        </kendo-dropdownlist>
      </div>
      <button
        kendoButton
        themeColor="primary"
        class="block basis-1/3"
        (click)="generateSummary()"
        [disabled]="loading()"
      >
        {{ 'outlook.buttons.summarize' | translate }}
      </button>
    </div>
    <!-- results -->
    <div class="grow scrollbar border-y border-neutral-30 p-2">
      @if (!loading()) {
        @if (summaryResults()) {
          <div
            class="h-full w-full text-body-2 text-neutral-90 overflow-y-auto scrollbar"
            [innerHTML]="displaySummary() | safeHtml"
          ></div>
        } @else {
          <div class="flex flex-col items-center justify-center gap-4 h-full">
            <img
              class="w-[80px]"
              [src]="cdn + '/assets/images/empty-container.svg'"
              [alt]="message.innerText"
            />
            <span #message class="text-body">
              {{ 'outlook.summarization.message.noSummary' | translate }}
            </span>
          </div>
        }
      }
    </div>
    <maximizer-outlook-ai-response-actions
      [aiFeature]="aiTimelineSummaryModule"
      [feedBackDisabled]="!summaryResults() || loading()"
      [feedbackGiven]="feedbackGiven()"
      [copyContent]="deAnonymizedSummary()"
      copySuccessKey="outlook.aiResponseActions.summaryCopySuccess"
      (feedbackVoted)="feedbackGiven.set(true)"
    ></maximizer-outlook-ai-response-actions>
  </div>
</kendo-dialog>

<ng-template #tooltipTemplate let-anchor>
  <p class="caption text-center text-neutral-90 whitespace-nowrap">
    {{ anchor.nativeElement.getAttribute('data-title') }}
  </p>
</ng-template>
